<template>
  <div id="lp">
    <section id="main-visual" class="main-visual">
      <div class="wrap">
        <div class="quote-link sp-none">
          <a @click="click('contact')">
            <p>無料の見積もりはこちら</p>
          </a>
        </div>

        <!--  TODO お問い合わせボタン LINK-->
        <div class="contact-link sp-none">
          <a @click="click('contact')">
            <picture>
              <source srcset="@/assets/img/pc/btn_tel.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/btn_tel.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/btn_tel.svg" alt="">
            </picture>
          </a>
        </div>

        <h1>通販サイト・店舗・イベントの集客</h1>
        <h2>シーククラウドは<br>オンライン広告で新規顧客開拓のお手伝いをいたします。</h2>
        <div class="banner">
          <div class="bagdge-y">
            <picture>
              <source srcset="@/assets/img/pc/img_badge-y.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_badge-y.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_badge-y.svg" alt="">
            </picture>
          </div>
          <div class="bagdge-g">
            <picture>
              <source srcset="@/assets/img/pc/img_badge-g.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_badge-g.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_badge-g.svg" alt="">
            </picture>
          </div>
          <div class="measure">
            <picture>
              <source srcset="@/assets/img/pc/img_measure.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_measure.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_measure.svg" alt="">
            </picture>
          </div>
        </div>
        <div class="circle">
          <div>15万円<br>から</div>
          <div>運用者全員<br>資格保持</div>
        </div>
      </div>

      <div class="scroll sp-none"><a @click="click('suggestion')">
        <picture>
          <source srcset="@/assets/img/pc/scroll.svg" media="(min-width: 681px)"/>
          <source srcset="@/assets/img/sp/scroll.svg" media="(max-width: 680px)"/>
          <img src="@/assets/img/pc/scroll.svg" alt="">
        </picture>
      </a></div>
    </section>

    <section id="suggestion" class="suggestion">
      <div class="contents">
        <h2 class="worry-title">このような課題やニーズはありませんか？</h2>
        <div class="worry">
          <picture>
            <source srcset="@/assets/img/pc/img_worry.svg" media="(min-width: 681px)"/>
            <source srcset="@/assets/img/sp/img_worry.svg" media="(max-width: 680px)"/>
            <img src="@/assets/img/pc/img_worry.svg" alt="" class="worry-img">
          </picture>
          <ul>
            <li>
              <picture>
                <source srcset="@/assets/img/pc/icon_check.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/icon_check.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/icon_check.svg" alt="">
              </picture>
              新しく通販サイトを開設したがなかなか集客につながらない
            </li>
            <li>
              <picture>
                <source srcset="@/assets/img/pc/icon_check.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/icon_check.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/icon_check.svg" alt="">
              </picture>
              現状の運用に不満や限界を感じてきている
            </li>
            <li>
              <picture>
                <source srcset="@/assets/img/pc/icon_check.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/icon_check.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/icon_check.svg" alt="">
              </picture>
              オンライン広告を出したいが、人・時間・ノウハウが足りない
            </li>
          </ul>
        </div>

        <div class="separate-line">
          <picture>
            <source srcset="@/assets/img/pc/img_line-arrow.svg" media="(min-width: 681px)"/>
            <source srcset="@/assets/img/sp/img_line-arrow.svg" media="(max-width: 680px)"/>
            <img src="@/assets/img/pc/img_line-arrow.svg" alt="">
          </picture>
        </div>

        <div class="solution">
          <h2 class="sp-none">シーククラウドはそれらの<br>課題・ニーズを解決いたします!</h2>
          <h2 class="pc-none">シーククラウドはそれらの<br>課題・ニーズを<br>解決いたします!</h2>
          <p class="sp-none">企業の皆さまのオンライン広告の導入を行う際に戦略立案から<br>効果検証までトータルでサポートいたします。</p>
          <p class="pc-none">企業の皆さまのオンライン広告の導入を<br>行う際に戦略立案から効果検証まで<br>トータルでサポートいたします。</p>
        </div>
      </div>
    </section>

    <section id="reason" class="reason">
      <div class="content-title">
        <h2>選ばれる3つのポイント<br><span>REASON</span></h2>
        <p>シーククラウドが選ばれる理由</p>
      </div>

      <div class="contents">
        <ul>
          <li class="point01">
            <div class="point">
              <div class="point-head right">
                <picture>
                  <source srcset="@/assets/img/pc/ttl_point_01.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/ttl_point_01.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/ttl_point_01.svg" alt="">
                </picture>
                <h3>長野県内でも数少ない正規広告代理店</h3>
              </div>
              <p class="sp-none">Google広告、Yahoo!広告の正規代理店です。<br>LINE広告、Twitter広告、Facebook広告、Instagram広告の運用も行っております。正規代理店ならではのノウハウでお客様の目標達成のお手伝いをいたします。</p>
              <p class="pc-none">Google広告、Yahoo!広告の正規代理店です。LINE広告、Twitter広告、<br>Facebook広告、Instagram広告の運用も行っております。正規代理店ならではのノウハウでお客様の目標達成のお手伝いをいたします。</p>
            </div>
            <div class="point-img right">
              <picture>
                <source srcset="@/assets/img/pc/img_point_01.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/img_point_01.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/img_point_01.svg" alt="">
              </picture>
            </div>
          </li>
          <li class="point02">
            <div class="point">
              <div class="point-head left">
                <picture>
                  <source srcset="@/assets/img/pc/ttl_point_02.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/ttl_point_02.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/ttl_point_02.svg" alt="">
                </picture>
                <h3>LPの制作から広告運用までワンストップ</h3>
              </div>
              <p class="sp-none">広告配信に必須なLPの制作もお任せください。<br>当社はホームページ制作、デザイン、広告運用を行っている会社ですので、トータルでサポートいたします。<br>LPとは：LP（ランディングページ）は商品やサービスに特化したウェブページのこと。今ご覧いただいている、このページもLPです。</p>
              <p class="pc-none">広告配信に必須なLPの制作もお任せください。当社はホームページ制作、デザイン、広告運用を行っている会社ですので、トータルでサポートいたします。<br>LPとは：LP（ランディングページ）は商品やサービスに特化したウェブページのこと。今ご覧いただいている、このページもLPです。</p>
            </div>
            <div class="point-img left">
              <picture>
                <source srcset="@/assets/img/pc/img_point_02.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/img_point_02.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/img_point_02.svg" alt="">
              </picture>
            </div>
          </li>
          <li class="point03">
            <div class="point">
              <div class="point-head right">
                <picture>
                  <source srcset="@/assets/img/pc/ttl_point_03.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/ttl_point_03.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/ttl_point_03.svg" alt="">
                </picture>
                <h3 class="bottom">地域密着サービス</h3>
              </div>
              <p>長野県の企業だから、長野県の企業に寄り添ったサービスを提供いたします。<br>土地柄がよく分かっているので、ターゲットの選定も的確です。対面でのミーティングができるので、困った時も安心です。</p>
            </div>
            <div class="point-img right">
              <picture>
                <source srcset="@/assets/img/pc/img_point_03.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/img_point_03.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/img_point_03.svg" alt="">
              </picture>
            </div>
          </li>
        </ul>

        <div class="contact-link" ontouchstart=””>
          <a @click="click('contact')">
            <picture>
              <source srcset="@/assets/img/pc/btn_form.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/btn_form.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/btn_form.svg" alt="">
            </picture>
          </a>
        </div>
      </div>
    </section>

    <section id="online-advertisement" class="online-advertisement">
      <div class="content-title">
        <h2>オンライン広告とは<br><span>ONLINE ADVERTISEMENT</span></h2>
        <p class="sp-none">GoogleやYahoo!、SNSに表示させることが出来る広告です。</p>
        <p class="pc-none">GoogleやYahoo!、SNSに<br>表示させることが出来る広告です。</p>
      </div>

      <div class="contents">
        <ul class="wrap">
          <li class="ad">
            <h3>Google,Yahoo!検索広告</h3>
            <ul>
              <li class="item1-1">
                <picture>
                  <source srcset="@/assets/img/pc/img_searchad_01.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_searchad_01.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_searchad_01.svg" alt="">
                </picture>
              </li>
              <li class="arrow arrow1">
                <picture>
                  <source srcset="@/assets/img/pc/img_arrow.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_arrow.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_arrow.svg" alt="">
                </picture>
              </li>
              <li class="item1-2">
                <picture>
                  <source srcset="@/assets/img/pc/img_searchad_02.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_searchad_02.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_searchad_02.svg" alt="">
                </picture>
              </li>
            </ul>
            <p>商材に関するキーワードで検索したユーザーへ広告を配信</p>
          </li>
          <li class="ad">
            <h3>SNS,ディスプレイ,DSP広告</h3>
            <ul>
              <li class="item2-1">
                <picture>
                  <source srcset="@/assets/img/pc/img_snsad_01.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_snsad_01.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_snsad_01.svg" alt="">
                </picture>
              </li>
              <li class="arrow arrow2">
                <picture>
                  <source srcset="@/assets/img/pc/img_arrow.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_arrow.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_arrow.svg" alt="">
                </picture>
              </li>
              <li class="item2-2">
                <picture>
                  <source srcset="@/assets/img/pc/img_snsad_02.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_snsad_02.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_snsad_02.svg" alt="">
                </picture>
              </li>
            </ul>
            <p>過去のウェブ上での行動から商材に興味があるであろうユーザーへ広告を配信</p>
          </li>
          <li id="merit" class="merit">
            <h3>オンライン広告のメリット</h3>
            <ul>
              <li class="merit01">
                <div class="head">
                  <div class="merit-img">
                    <picture>
                      <source srcset="@/assets/img/pc/img_merit_01.svg" media="(min-width: 681px)"/>
                      <source srcset="@/assets/img/sp/img_merit_01.svg" media="(max-width: 680px)"/>
                      <img src="@/assets/img/pc/img_merit_01.svg" alt="">
                    </picture>
                  </div>
                  <div class="merit-title">
                    <p>MERIT.<span>01</span></p>
                    <p>見込み顧客にピンポイントで<br>アプローチできる</p>
                  </div>
                </div>
                <div class="detail sp-none">今検索しているユーザーや、商材に興味がある<br>ユーザーに広告を配信できるため費用対効果が高い</div>
                <div class="detail pc-none">今検索しているユーザーや、商材に興味があるユーザーに広告を配信できるため費用対効果が高い</div>
              </li>

              <li class="merit02">
                <div class="head">
                  <div class="merit-img">
                    <picture>
                      <source srcset="@/assets/img/pc/img_merit_02.svg" media="(min-width: 681px)"/>
                      <source srcset="@/assets/img/sp/img_merit_02.svg" media="(max-width: 680px)"/>
                      <img src="@/assets/img/pc/img_merit_02.svg" alt="">
                    </picture>
                  </div>
                  <div class="merit-title">
                    <p>MERIT.<span>02</span></p>
                    <p>効果測定が可能</p>
                  </div>
                </div>
                <div class="detail">広告からのサイト誘導数・購入件数がデータとして 可視化されるため、効果を実感できる</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>

    <section id="service" class="service">
      <div class="content-title">
        <h2>取り扱い商品一覧<br><span>SERVICE</span></h2>
      </div>

      <div class="contents">
        <ul>
          <li class="wrap">
            <picture>
              <source srcset="@/assets/img/pc/img_ggl.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_ggl.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_ggl.svg" alt="">
            </picture>
            <h3 class="google">Google広告</h3>
            <ul class="fb">
              <li>・検索広告</li>
              <li>・Googleディスプレイ広告</li>
              <li>・YouTube</li>
              <li class="sp-none">・Googleショッピング広告</li>
              <li class="pc-none">・Googleショッピング<br> 広告</li>
            </ul>
          </li>
          <li class="wrap">
            <picture>
              <source srcset="@/assets/img/pc/img_yahoo.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_yahoo.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_yahoo.svg" alt="">
            </picture>
            <h3 class="yahoo">Yahoo!広告</h3>
            <ul>
              <li>・検索広告</li>
              <li>・Yahoo!ディスプレイ広告</li>
              <li>・動画広告</li>
              <li>・プレミアム広告</li>
            </ul>
          </li>
          <li class="wrap">
            <picture>
              <source srcset="@/assets/img/pc/img_fb.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_fb.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_fb.svg" alt="">
            </picture>
            <h3 class="facebook">Facebook広告</h3>
            <ul>
              <li>・画像広告</li>
              <li>・動画広告</li>
              <li>・コレクション広告</li>
              <li>・リード獲得広告</li>
            </ul>
          </li>
          <li class="wrap">
            <picture>
              <source srcset="@/assets/img/pc/img_insta.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_insta.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_insta.svg" alt="">
            </picture>
            <h3 class="instagram">Instagram広告</h3>
            <ul>
              <li>・画像広告</li>
              <li>・動画広告</li>
              <li>・ストーリーズ広告</li>
              <li>・コレクション広告</li>
            </ul>
          </li>
          <li class="wrap">
            <picture>
              <source srcset="@/assets/img/pc/img_twt.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_twt.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_twt.svg" alt="">
            </picture>
            <h3 class="twitter">Twitter広告</h3>
            <ul>
              <li>・画像広告</li>
              <li>・動画広告</li>
              <li>・テキストのみ広告</li>
              <li>・フォロワー獲得広告</li>
            </ul>
          </li>
          <li class="wrap">
            <picture>
              <source srcset="@/assets/img/pc/img_line.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_line.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_line.svg" alt="">
            </picture>
            <h3 class="line">LINE広告</h3>
            <ul class="line">
              <li>・画像広告</li>
              <li>・動画広告</li>
              <li>・友達追加広告</li>
              <li></li>
            </ul>
          </li>
          <li class="wrap">
            <picture>
              <source srcset="@/assets/img/pc/img_dsp.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_dsp.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_dsp.svg" alt="">
            </picture>
            <h3 class="dsp">DSP</h3>
            <ul class="dsp">
              <li>・位置情報広告</li>
              <li>・人工知能活用</li>
              <li></li>
              <li></li>
            </ul>
          </li>
        </ul>

        <div class="contact-link" ontouchstart=””>
          <a @click="click('contact')">
            <picture>
              <source srcset="@/assets/img/pc/btn_form.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/btn_form.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/btn_form.svg" alt="">
            </picture>
          </a>
        </div>
      </div>
    </section>

    <section id="case" class="case">
      <div class="content-title">
        <h2>事 例<br><span>CASE</span></h2>
      </div>

      <div class="contents">
        <ul>
          <li class="case-wrap">
            <div>
              <div>
                <p class="color">通販サイト A社様</p>
                <p class="bold">月間売上4倍UP！</p>
              </div>
              <div>
                <p class="border">主な施策</p>
                <picture>
                  <source srcset="@/assets/img/pc/img_measure_a.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_measure_a.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_measure_a.svg" alt="" class="measure">
                </picture>
                <ul>
                  <li>・多数の商品にあわせた広告文の表示</li>
                  <li>・SNS広告による新規顧客の獲得</li>
                  <li>・アナリティクスによる分析</li>
                </ul>
              </div>
            </div>
            <div>
              <picture>
                <source srcset="@/assets/img/pc/img_a.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/img_a.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/img_a.svg" alt="" class="case-img img-a">
              </picture>
              <ul class="remarks">
                <li><span>※</span>CV = コンバージョン。広告によって、「購入」や「予約」に繋がった件数。</li>
                <li><span>※</span>CPA = 1コンバージョンに対してかかった費用。広告費÷コンバージョン数で算出される。安ければ安いほどよい。</li>
              </ul>
            </div>
          </li>
          <li class="case-wrap">
            <div>
              <div>
                <p class="color">住宅イベント B社様</p>
                <p class="bold">イベント予約件数 <br class="pc-none">40件以上！</p>
              </div>
              <div>
                <p class="border">主な施策</p>
                <picture>
                  <source srcset="@/assets/img/pc/img_measure_b.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_measure_b.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_measure_b.svg" alt="" class="measure">
                </picture>
                <ul>
                  <li>・人気の高い「平屋」のキーワードの運用</li>
                  <li>・マイクロコンバージョン※の設定による<br> 見込みユーザーの獲得</li>
                  <li class="attention">※コンバージョン到達の手前に発生するアクション</li>
                </ul>
              </div>
            </div>
            <div>
              <picture>
                <source srcset="@/assets/img/pc/img_b.svg" media="(min-width: 681px)"/>
                <source srcset="@/assets/img/sp/img_b.svg" media="(max-width: 680px)"/>
                <img src="@/assets/img/pc/img_b.svg" alt="" class="case-img img-b">
              </picture>
              <ul class="remarks">
                <li><span>※</span>CV = コンバージョン。広告によって、「購入」や「予約」に繋がった件数。</li>
                <li><span>※</span>LP = ランディングページ。商品やサービスに特化したウェブページのこと。</li>
              </ul>
            </div>
          </li>
          <li class="case-wrap">
            <div>
              <div>
                <p class="color">車販売 C社様</p>
                <p class="bold">サイト訪問者数<br>2倍UP</p>
              </div>
              <div>
                <p class="border">主な施策</p>
                <picture>
                  <source srcset="@/assets/img/pc/img_measure_c.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_measure_c.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_measure_c.svg" alt="" class="measure">
                </picture>
                <ul>
                  <li>・ブランドイメージに沿ったLPの制作</li>
                  <li>・他社との差別化を図った広告文の作成</li>
                  <li>・ターゲット層の洗い出し</li>
                </ul>
              </div>
            </div>
            <picture>
              <source srcset="@/assets/img/pc/img_c.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_c.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_c.svg" alt="" class="case-img img-c">
            </picture>
          </li>
        </ul>
      </div>
    </section>

    <section id="flow" class="flow">
      <div class="content-title">
        <h2>掲載開始までの流れ<br><span>FLOW</span></h2>
        <p class="sp-none">お申込み・ご契約から最短2週間で運用開始が可能です。</p>
        <p class="pc-none">お申込み・ご契約から最短2週間で<br>運用開始が可能です。</p>
      </div>

      <div class="contents">
        <ul class="sp-none">
          <li class="step">
            <picture>
              <source srcset="@/assets/img/pc/ttl_step_01.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/ttl_step_01.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/ttl_step_01.svg" alt="" class="title-number">
            </picture>
            <div class="title">
              <div>
                <picture>
                  <source srcset="@/assets/img/pc/img_step_01.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_step_01.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_step_01.svg" alt="" class="step_01">
                </picture>
              </div>
              <span>お問い合わせ</span>
            </div>
            <div class="text">お問い合わせフォームからご連絡ください。<br>※制作会社様、広告代理店様からのお問い合わせも受け付けております。</div>
          </li>
          <li class="next"></li>
          <li class="step">
            <picture>
              <source srcset="@/assets/img/pc/ttl_step_02.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/ttl_step_02.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/ttl_step_02.svg" alt="" class="title-number">
            </picture>
            <div class="title">
              <div>
                <picture>
                  <source srcset="@/assets/img/pc/img_step_02.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_step_02.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_step_02.svg" alt="" class="step_02">
                </picture>
              </div>
              <span>ミーティング</span>
            </div>
            <div class="text">お客様のサービスについてや現状の課題等をヒアリングいたします。<br>ヒアリングに基づき、最適なご提案をご用意いたします。</div>
          </li>
          <li class="next"></li>
          <li class="step">
            <picture>
              <source srcset="@/assets/img/pc/ttl_step_03.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/ttl_step_03.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/ttl_step_03.svg" alt="" class="title-number">
            </picture>
            <div class="title">
              <div>
                <picture>
                  <source srcset="@/assets/img/pc/img_step_03.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/img_step_03.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/img_step_03.svg" alt="" class="step_03">
                </picture>
              </div>
              <span>ご契約・広告配信</span>
            </div>
            <div class="text">ご提案内容に合意頂き、契約を締結します。<br>ご契約後、広告の配信準備が完了次第配信開始となります。</div>
          </li>
        </ul>

        <!-- Slider main container -->
        <div class="swiper-container pc-none">

          <!-- Additional required wrapper -->
          <swiper
              :slides-per-view="1"
              :navigation="{ clickable: true, nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }"
              :pagination="{ clickable: true }"
          >
            <!-- Slides -->
            <swiper-slide>
              <div class="step">
                <picture>
                  <source srcset="@/assets/img/pc/ttl_step_01.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/ttl_step_01.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/ttl_step_01.svg" alt="" class="title-number">
                </picture>
                <div class="title">
                  <div>
                    <picture>
                      <source srcset="@/assets/img/pc/img_step_01.svg" media="(min-width: 681px)"/>
                      <source srcset="@/assets/img/sp/img_step_01.svg" media="(max-width: 680px)"/>
                      <img src="@/assets/img/pc/img_step_01.svg" alt="" class="step_01">
                    </picture>
                  </div>
                  <span>お問い合わせ</span>
                </div>
                <div class="text">お問い合わせフォームからご連絡ください。<br>※制作会社様、広告代理店様からのお問い合わせも受け付けております。</div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="step">
                <picture>
                  <source srcset="@/assets/img/pc/ttl_step_02.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/ttl_step_02.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/ttl_step_02.svg" alt="" class="title-number">
                </picture>
                <div class="title">
                  <div>
                    <picture>
                      <source srcset="@/assets/img/pc/img_step_02.svg" media="(min-width: 681px)"/>
                      <source srcset="@/assets/img/sp/img_step_02.svg" media="(max-width: 680px)"/>
                      <img src="@/assets/img/pc/img_step_02.svg" alt="" class="step_02">
                    </picture>
                  </div>
                  <span>ミーティング</span>
                </div>
                <div class="text">お客様のサービスについてや現状の課題等をヒアリングいたします。<br>ヒアリングに基づき、最適なご提案をご用意いたします。</div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="step">
                <picture>
                  <source srcset="@/assets/img/pc/ttl_step_03.svg" media="(min-width: 681px)"/>
                  <source srcset="@/assets/img/sp/ttl_step_03.svg" media="(max-width: 680px)"/>
                  <img src="@/assets/img/pc/ttl_step_03.svg" alt="" class="title-number">
                </picture>
                <div class="title">
                  <div>
                    <picture>
                      <source srcset="@/assets/img/pc/img_step_03.svg" media="(min-width: 681px)"/>
                      <source srcset="@/assets/img/sp/img_step_03.svg" media="(max-width: 680px)"/>
                      <img src="@/assets/img/pc/img_step_03.svg" alt="" class="step_03">
                    </picture>
                  </div>
                  <span>ご契約・広告配信</span>
                </div>
                <div class="text">ご提案内容に合意頂き、契約を締結します。<br>ご契約後、広告の配信準備が完了次第配信開始となります。</div>
              </div>
            </swiper-slide>
          </swiper>

          <!-- If we need pagination -->
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>


        <div class="contact-link" ontouchstart=””>
          <a @click="click('contact')">
            <picture>
              <source srcset="@/assets/img/pc/btn_form.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/btn_form.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/btn_form.svg" alt="">
            </picture>
          </a>
        </div>
      </div>
    </section>

    <section id="price" class="price">
      <div class="content-title">
        <h2>料金について<br><span>PRICE</span></h2>
      </div>

      <div class="contents">
        <ul>
          <li class="wrap">
            <div class="table-wrap">
              <div class="table">
                <div class="th">運用費</div>
                <div class="td">
                  <div class="color">月額広告費の <span>20</span>%</div>
                  <ul>
                    <li>・日々の運用・管理</li>
                    <li>・改善のための提案</li>
                    <li>・月次レポート</li>
                  </ul>
                </div>
              </div>
              <div class="table">
                <div class="th">初期費用</div>
                <div class="td">
                  <div class="tr">
                    <div>Google ＆ Yahoo!</div>
                    <div><span>3</span>万円</div>
                  </div>
                  <div class="tr">
                    <div>Facebook ＆ Instagram</div>
                    <div><span>2</span>万円</div>
                  </div>
                  <div class="tr">
                    <div>Twitter</div>
                    <div><span>2</span>万円</div>
                  </div>
                  <div class="tr">
                    <div>LINE</div>
                    <div><span>1</span>万円</div>
                  </div>
                </div>
              </div>
              <div class="table">
                <div class="th">最低契約期間</div>
                <div class="td"><span>3</span>ヶ月</div>
              </div>
            </div>
            <ul class="attention">
              <li>※月額広告費が100万円以上の場合、初期費用は無料です。</li>
              <li>※月額広告費が25万円未満の場合、運用費は一律で5万円となります。</li>
              <li>※最低出稿額は15万円です。</li>
              <li>※15万円～25万円未満の広告費の場合、月次レポートは数値のみのレポートとなります。</li>
              <li>※一度に3種以上の媒体お申し込みの場合、初期費用は2割引いたします。</li>
            </ul>
          </li>

          <li class="wrap">
            <h3>料金シミュレーション</h3>
            <p class="sp-none">■ご予算100万円の場合 [媒体：Google、Yahoo!、LINE]</p>
            <p class="pc-none">■ご予算100万円の場合<br>[媒体：Google、Yahoo!、LINE]</p>
            <picture>
              <source srcset="@/assets/img/pc/img_simulation.svg" media="(min-width: 681px)"/>
              <source srcset="@/assets/img/sp/img_simulation.svg" media="(max-width: 680px)"/>
              <img src="@/assets/img/pc/img_simulation.svg" alt="">
            </picture>
          </li>
        </ul>
      </div>
    </section>

    <section id="faq" class="faq">
      <div class="content-title">
        <h2>よくあるご質問<br><span>FAQ</span></h2>
      </div>

      <div class="contents">
        <ul>
          <li>
            <p class="question">Q. 最低出稿期間はありますか？</p>
            <p class="answer">A. 3ヶ月です。</p>
            <p class="detail">安定した運用・継続的な成果確保のため、新規ご契約時は最低運用期間を 3 ヶ月 とさせて頂きます。キャンペーンのプロモーションなど、 あらかじめ 3 ヶ月未満の実施を予定されている場合は、ご相談ください。</p>
          </li>
          <li>
            <p class="question">Q. 定例報告会などはありますか？</p>
            <p class="answer">A. オプションで行っております。</p>
            <p class="detail">・オンラインでの報告会：1万円<br class="pc-none"><span class="pc-none">&emsp;</span>（1回/月※1h程度を想定）<br>・直接御社へ訪問させて頂く場合：3万円<br class="pc-none"><span class="pc-none">&emsp;</span>（1回/月※1h程度を想定）<br><span class="indent2em">&boxur;対象エリア:長野県※南信地域は除く</span><br><span class="indent3em">上記以外のエリアの場合は別途ご相談となります。</span></p>
          </li>
          <li>
            <p class="question">Q. 15万円以下の広告費で出稿できますか？</p>
            <p class="answer">A. 大変申し訳ございませんが、承っておりません。</p>
            <p class="detail">少額での配信ですと、システム学習のためのデータが蓄積されず効果が出にくいです。また、昨今はインターネット広告における競合が多くなっており、広告の露出がごく少なくなってしまい、正確な運用判断ができかねます。</p>
          </li>
          <li>
            <p class="question">Q. 月次レポートの内容はどのようなものになりますか？</p>
            <p class="answer">A. 配信実績と運用の履歴、次月の改善を記載したレポートを提出いたします。</p>
            <p class="detail">毎月の月初5営業日以内に提出いたします。レポートのサンプルがありますので、ご興味のある方はお問い合わせフォームよりご連絡ください。15万円～25万円未満の広告費の場合、月次レポートは数値のみのレポートとなります。<br>ご希望に応じて詳細なレポートを有料でつけることも可能です。詳しくはお問い合わせください。</p>
          </li>
          <li>
            <p class="question">Q. 既に広告用のアカウントをもっているのですが、使用しますか？</p>
            <p class="answer">A. 弊社で新規に開設いたします。</p>
            <p class="detail">通常、広告アカウントは弊社で新規に開設いたします。契約終了後のアカウントの譲渡は致しかねます。</p>
          </li>
          <li>
            <p class="question">Q. 既にホームページを持っているのですが、LPは必要ですか？</p>
            <p class="answer">A. LPを作ることを推奨しますが、ホームページの内容によります。</p>
            <p class="detail">ホームページは、広告する商品やイベント以外の情報量が多く、ユーザーが迷子になってしまいます。<br>それに対しLP（ランディングページ）は、基本的に1ページのみに商品やイベント情報をつめこむ構成になっています。<br>ユーザーは目当ての商品の情報をすぐに得ることができ、「購入」「予約」などに繋がりやすくなります。<br>そのため、LP（ランディングページ）の制作を推奨しております。お客様がお持ちのホームページの内容によっては、LP（ランディングページ）が必要がない場合もあります（もともと広告する商品に特化した内容のHPである 等）。<br>お客様のホームページの内容を拝見させていただき、LP（ランディングページ）の要否について最適なご提案をいたします。</p>
          </li>
          <li>
            <p class="question">Q. シーククラウドはどのような会社なのですか？</p>
            <p class="answer">A. 長野県上田市で、ウェブに関する仕事をしています。</p>
            <p class="detail">株式会社Seekcloud(シーククラウド)は、長野県上田市でウェブ制作／システム開発を行っております。ホームページ制作、デザイン制作、システム開発、Webマーケティングなどを行っております。オンライン広告のみならず、ウェブに関することは何でもご相談ください。</p>
          </li>
        </ul>

      </div>
    </section>

    <section id="contact" class="contact">
      <div class="content-title">
        <h2>お問い合わせ<br><span>CONTACT</span></h2>
        <p>電話、もしくはフォームから<br class="pc-none">お気軽にお問い合わせください。</p>

        <div class="tel-block">
          <div><a class="tel-btn" href="tel:0268-71-0740">TEL：0268-71-0740</a></div>
          <div class="hours">(営業時間 9：00～18：00)</div>
        </div>

        <div class="form-btn-wrap">
          <div class="form-btn"><a href="https://www.seekcloud.co.jp/contact">フォームはこちら</a></div>
        </div>
      </div>


      <!--    <div class="container">-->
      <!--      <Form @submit="submit">-->

      <!--        <div class="wrap">-->
      <!--          <p>-->
      <!--            <label>お名前<span class="required">必須</span></label>-->
      <!--            <span class="name-in">-->
      <!--              <label for="fname" class="in sei">姓</label>-->
      <!--              <Field name="名字" rules="required" class="size-25" v-model="fname" />-->
      <!--              <ErrorMessage name="名字" class="msg-fname"/>-->
      <!--              <label for="lname" class="in mei">名</label>-->
      <!--              <Field name="お名前" rules="required" class="size-25" v-model="lname" />-->
      <!--              <ErrorMessage name="お名前" class="msg-lname"/>-->
      <!--            </span>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="company-name">会社名<span class="required">必須</span></label>-->
      <!--            <Field name="会社名" rules="required" class="size-25" v-model="companyName" />-->
      <!--            <ErrorMessage name="会社名" class="msg"/>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="company-url">会社URL</label>-->
      <!--            <input name="会社URL" class="size-55" v-model="companyUrl"/>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="mail-address">メールアドレス<span class="required">必須</span></label>-->
      <!--            <Field name="メールアドレス" rules="email" class="size-55" v-model="mailAddress"/>-->
      <!--            <ErrorMessage name="メールアドレス" class="msg"/>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="tel">電話番号<span class="required">必須</span></label>-->
      <!--            <Field name="電話番号" rules="required" class="size-55" v-model="tel"/>-->
      <!--            <ErrorMessage name="電話番号" class="msg"/>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="budget">ご予算</label>-->
      <!--            <select id="budget" name="budget" class="size-30" v-model="budget">-->
      <!--              <option value="">選択してください</option>-->
      <!--              <option>〜20万円</option>-->
      <!--              <option>20〜40万円</option>-->
      <!--              <option>40〜70万円</option>-->
      <!--              <option>70〜100万円</option>-->
      <!--              <option>100万円〜</option>-->
      <!--              <option>未定</option>-->
      <!--            </select>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="advertise-site">広告するサイトURL</label>-->
      <!--            <input type="text" id="advertise-site" class="size-55" v-model="advertiseSite"/>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="start">広告開始希望時期</label>-->
      <!--            <select id="start" name="start" class="size-30" v-model="start">-->
      <!--              <option value="">選択してください</option>-->
      <!--              <option>未定</option>-->
      <!--              <option>1ヶ月以内</option>-->
      <!--              <option>1ヶ月～3ヶ月後</option>-->
      <!--              <option>3ヶ月～5ヶ月後</option>-->
      <!--              <option>半年後</option>-->
      <!--              <option>1年後</option>-->
      <!--            </select>-->
      <!--          </p>-->
      <!--          <p>-->
      <!--            <label for="" class="adjustment">お問い合わせ内容</label>-->
      <!--            <input type="checkbox" id="inquiry-soudan" name="inquiry-soudan" value="ご相談" v-model="inquiry"/>-->
      <!--            <label for="inquiry-soudan" class="in padding">ご相談</label>-->
      <!--            <input type="checkbox" id="inquiry-mitsumori" name="inquiry-mitsumori" value="お見積り" v-model="inquiry"/>-->
      <!--            <label for="inquiry-mitsumori" class="in padding">お見積り</label>-->
      <!--            <input type="checkbox" id="inquiry-sonota" name="inquiry-sonota" value="その他" v-model="inquiry"/>-->
      <!--            <label for="inquiry-sonota" class="in padding">その他</label>-->
      <!--          </p>-->
      <!--          <p class="adjustment">-->
      <!--            <label for="subject">お問い合わせ内容詳細</label>-->
      <!--            <textarea id="subject" name="subject" class="size-55" v-model="subject"></textarea>-->
      <!--          </p>-->

      <!--          <ul class="attention">&lt;!&ndash; TODO PP LINK &ndash;&gt;-->
      <!--            <li><a href="https://www.seekcloud.co.jp/privacy" target="_blank" rel="noopener">プライバシーポリシー</a>をご確認・ご同意の上送信してください。</li>-->
      <!--            <li>※土日祝日、年末年始、長期休業期間等につきましては、翌営業日以降の対応となりますのでご了承ください。</li>-->
      <!--            <li>※万が一弊社から折り返しのご連絡がない場合、大変恐れ入りますが下記電話番号までお問い合わせください。<br><span class="sp-none">&ensp;</span>お問い合わせ先：0268-71-0740</li>-->
      <!--          </ul>-->

      <!--          <div class="pp">-->
      <!--            <Field type="checkbox" name="プライバシーポリシーへの同意" :rules="isChecked" id="privacy-policy" value="on"/>-->
      <!--            <ErrorMessage name="プライバシーポリシーへの同意" class="msg-pp"/>-->
      <!--            <label for="privacy-policy">プライバシーポリシーに同意する</label>-->
      <!--          </div>-->

      <!--          <p><input type="submit"></p>-->

      <!--        </div>-->
      <!--      </Form>-->
      <!--    </div>-->

    </section>

  </div>
</template>
<script>

import SwiperCore, {Navigation, Pagination} from 'swiper';

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

// Register the Field and Form components and create a simple required validator:
// import { Field, Form, ErrorMessage } from 'vee-validate';
// You can then start importing and defining rules globally:
import {configure, defineRule} from 'vee-validate';
import {email, min, required} from '@vee-validate/rules';

// import the localize() function from @vee-validate/i18n which returns a message generator function:
import {localize} from '@vee-validate/i18n';
import ja from "@vee-validate/i18n/dist/locale/ja.json";

defineRule('required', required);
defineRule('email', email);
defineRule('min', min);

configure({
  generateMessage: localize('ja', {
    messages: ja.messages,
  }),
});

SwiperCore.use([Navigation, Pagination]);

export default {

  data() {
    return {
      fname: "",
      lname: "",
      companyName: "",
      companyUrl: "",
      mailAddress: "",
      tel: "",
      budget: "",
      advertiseSite: "",
      start: "",
      inquiry: [],
      subject: "",
    }
  },

  components: {
    Swiper,
    SwiperSlide,
    // Field,
    // Form,
    // ErrorMessage,
  },

  mounted() {

    let id = this.$route.params.id;
    if (id) {
      let to = document.getElementById(id);
      let top = to.offsetTop;
      window.scrollTo({
        top: top,
      })
    } else {
      window.scrollTo({
        top: 0,
      })
    }

  },

  methods: {

    click: function (id) {

      let to = document.getElementById(id);
      let top = to.offsetTop;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })

    },
    isChecked(value) {
      if (value === "on") {
        return true;
      }
      return "プライバシーポリシーへの同意は必須です。";
    },
    submit: function () {

      this.$router.push({
        name: 'Check',
        params: {
          fname: this.fname,
          lname: this.lname,
          companyName: this.companyName,
          companyUrl: this.companyUrl,
          mailAddress: this.mailAddress,
          tel: this.tel,
          budget: this.budget,
          advertiseSite: this.advertiseSite,
          start: this.start,
          inquiry: this.inquiry,
          subject: this.subject,
        }
      });
    }
  },
};
</script>
